/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:46:53
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
// import * as analyticsActions from 'src/stores/actions/analytics-actions';

import Collections from 'src/components/containers/analytics/collections';
import Searches from 'src/components/containers/analytics/searches';
import Settings from 'src/components/containers/analytics/settings';

type Props = WithI18nProps;
class AnalyticsTabs extends Component<Props> {
  render() {
    const {
      selectedTab,
      onChangeTab,
      performActionSurvey,
      enableOrderRevenue,
      updatePermissionLink,
      i18n
    } = this.props;
    const tabs = [
      {
        id: 'collections-analytics',
        content: i18n.translate('AdminHTML.Analytics.AnalyticsTabs.analyticsTabs_TabContent_CollectionsAnalytics'),
        panelID: 'collections-analytics'
      },
      {
        id: 'search-analytics',
        content: i18n.translate('AdminHTML.Analytics.AnalyticsTabs.analyticsTabs_TabContent_SearchAnalytics'),
        panelID: 'search-analytics'
      },
      {
        id: 'settings-analytics',
        content: i18n.translate('AdminHTML.Analytics.AnalyticsTabs.analyticsTabs_TabContent_Settings'),
        panelID: 'settings-analytics'
      }
    ];

    const tabComponents = [
      <Collections performActionSurvey={performActionSurvey} />,
      <Searches performActionSurvey={performActionSurvey} />,
      <Settings
        enableOrderRevenue={enableOrderRevenue}
        updatePermissionLink={updatePermissionLink}
      />
    ];

    return (
      <div className="BC-Analytics__Tabs">
        <Tabs tabs={tabs} selected={selectedTab} onSelect={onChangeTab}>
          {tabComponents[selectedTab]}
        </Tabs>
      </div>
    );
  }
}

export default withI18n()(AnalyticsTabs);
